import React from "react";
import cash from "../../assets/services/cash.png";
import visa from "../../assets/services/visa.png";
import security from "../../assets/services/security.png";
import master from "../../assets/services/master.png";
import mada from "../../assets/services/mada.png";
import pay from "../../assets/services/apple-pay.png";
import paypal from "../../assets/services/paypal.png";
import time from "../../assets/time.png";
import { useTranslation } from "react-i18next";
import am from "../../assets/services/ami.jpeg";

const PaymentMethod = () => {
  const { t, i18n } = useTranslation();

  const { language } = i18n;

  return (
    <div className="my-20 px-20 max-lg:px-5 relative">
      <div className="text-center">
        <h2 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
          {t("Accepted Payment Methods")}
        </h2>
        <p className="text-[#737E91] text-lg mt-3">
          {t("And enjoy exclusive deals & promotions")}
        </p>
      </div>
      <div className="lg:flex justify-center lg:items-center mx-auto mt-8">
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={mada} className="w-[100px] mx-auto py-6" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("Mada")}</p>
        </div>
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={visa} className="w-[100px] mx-auto py-7" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("Visa")}</p>
        </div>
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto py-5">
            <img src={master} className="w-[100px] mx-auto bg-[#3c80ad] rounded-lg" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("MasterCard")}</p>
        </div>
        {/* <div className="max-lg:mx-auto">
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={cash} className="w-[100px] mx-auto pt-2" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("Cash")}</p>
        </div> */}
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={am} className="w-[80px] mx-auto py-2 rounded-xl" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("AmericanExpress")}</p>
        </div>
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={pay} className="w-[100px] mx-auto py-7" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("Pay")}</p>
        </div>
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={paypal} className="w-[100px] mx-auto py-8" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("PayPal")}</p>
        </div>
        <div
          className={`max-lg:mx-auto max-lg:mt-5 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <div className="bg-[#FCFBFA] rounded-xl w-[150px] h-[100px] max-lg:mx-auto">
            <img src={cash} className="w-[80px] mx-auto py-2" />
          </div>
          <p className="text-[#14294F] text-xl text-center mt-3">{t("Cash")}</p>
        </div>
      </div>

      <div className="lg:flex justify-center mt-4">
        <div className="bg-[#FCFBFA] rounded-full flex items-center justify-center border-2 border-[#EAA182] w-[350px] h-[90px] max-lg:w-full mt-8">
          <img src={security} className="w-[50px]" />
          <div
            className={`text-[#737E91] ${language == "en" ? "ml-3" : "mr-3"}`}
          >
            <p className="text-xl">{t("Secure Payment Methods")}</p>
          </div>
        </div>
        <div
          className={`bg-[#FCFBFA] rounded-full flex items-center justify-center border-2 border-[#EAA182] w-[350px] h-[90px] max-lg:w-full mt-8 ${
            language == "en" ? "lg:ml-5" : "lg:mr-5"
          }`}
        >
          <img src={time} className="w-[50px]" />
          <div
            className={`text-[#737E91] ${language == "en" ? "ml-3" : "mr-3"}`}
          >
            <p className="text-xl">{t("24/7 Support")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
